import { enqueueSnackbar } from 'notistack';
import { createAction } from 'redux-actions';

import { resetForm } from '@gef-ui/form-core/stream/transfer/control';
import { getMessage } from '@gef-ui/localization/messages';

import fetch from 'features/common/fetch';
import { getFirstName, getSurname } from 'features/views/user/selectors';
import { history } from 'utils';

import { ADD_LEAD_NOTE, RESET_REDUCER, SET_LEAD_DETAILS, SET_LEAD_HISTORY } from './actionTypes';
import { FIELDS, LEAD_DETAIL_FORM } from './form';

const setLeadDetails = createAction(SET_LEAD_DETAILS, (details) => ({ details }));
const setLeadHistory = createAction(SET_LEAD_HISTORY, (history) => ({ history }));
export const resetReducer = createAction(RESET_REDUCER);
export const addNote = createAction(ADD_LEAD_NOTE, (comment, firstName, surname) => ({ comment, firstName, surname }));

export const resetLeadDetail =
	() =>
	(dispatch, getState, { sendControlNext }) => {
		dispatch(resetReducer());
		sendControlNext(LEAD_DETAIL_FORM, resetForm());
	};

export const fetchLeadDetails = (leadId) => (dispatch) => {
	dispatch(
		fetch.actions.get(fetch.constants.urls.leadDetail, {
			replaceParams: { id: leadId },
			onSuccess: [
				({ body }) =>
					() => {
						dispatch(setLeadDetails(body));
					},
			],
		}),
	);
};

export const returnLeadToMarketPlace = (leadId) => (dispatch) => {
	dispatch(
		fetch.actions.put(fetch.constants.urls.returnLead, {
			replaceParams: { id: leadId },
			onSuccess: [
				() => () => {
					// back to origin location - either marketplace or dashboard
					history.go(-1);
				},
			],
		}),
	);
};

export const fetchLeadHistory = (leadId) => (dispatch) => {
	dispatch(
		fetch.actions.get(fetch.constants.urls.taskHistory, {
			replaceParams: { id: leadId },
			onSuccess: [
				({ body }) =>
					() => {
						dispatch(setLeadHistory(body));
					},
			],
		}),
	);
};

export const postNote =
	(leadId) =>
	async (dispatch, getState, { getFormFieldValue, sendControlNext }) => {
		const note = await getFormFieldValue({
			formName: LEAD_DETAIL_FORM,
			fieldName: FIELDS.note,
		});

		const firstName = getFirstName(getState());
		const surname = getSurname(getState());

		return dispatch(
			fetch.actions.post(fetch.constants.urls.leadNote, {
				replaceParams: { id: leadId },
				body: { note },
				onSuccess: [
					() => () => {
						dispatch(addNote(note, firstName, surname));
						enqueueSnackbar(getMessage('toastr:approveTextHeader'), { variant: 'success' });
						sendControlNext(LEAD_DETAIL_FORM, resetForm());
					},
				],
				onError: [() => enqueueSnackbar(getMessage('toastr:errorTextHeader'), { variant: 'error' })],
			}),
		);
	};

export const openLead = (leadId) => (dispatch) => {
	dispatch(
		fetch.actions.post(fetch.constants.urls.leadOpen, {
			replaceParams: { id: leadId },
			onSuccess: [
				() => () => {
					dispatch(fetchLeadDetails(leadId));
					dispatch(fetchLeadHistory(leadId));
				},
			],
			//onError logic - in LeadDetail useEffect because of "navigate"
			shouldReportError: ({ failure }) => {
				return failure?.status !== 403;
			},
		}),
	);
};
